import SimpleModel from '../../classes/SimpleModel/SimpleModel';
import UserPreferencesRepository from './UserPreferencesRepository';
import app from '../../helpers/app';
import {UserPreferenceEvents} from '../../@types/services/Auth/UserPreferenceEvents';
import {IUserPreference} from '../../@interfaces/services/Auth/IUserPreference';
import {IUserPreferenceModel} from '../../@interfaces/models/User/IUserPreferenceModel';

const requestSender: typeof fetch = (() => {
    let batchRequestBody: Record<any, any>[] = [];
    let batchTimer: NodeJS.Timeout | null = null;
    // noinspection JSMismatchedCollectionQueryUpdate
    let promisesQueue: {
        resolve: (value: Response | PromiseLike<Response>) => void,
        reject: (reason?: any) => void,
    }[] = [];

    return (input, init?: RequestInit) => {
        if (batchTimer) {
            clearTimeout(batchTimer);
        }

        batchRequestBody.push(JSON.parse(init?.body as string));
        batchTimer = setTimeout(() => {
            const queue = promisesQueue;

            app('http').withRawResponse(http => {
                return http.route('profile.update-multiple-preferences', {}, {
                    headers: {'Content-Type': 'application/json'},
                    body: batchRequestBody,
                });
            }).then(rawResponse => {
                queue.forEach(({resolve}) => resolve(rawResponse.clone()));
            }, error => {
                queue.forEach(({reject}) => reject(error));
            });

            batchRequestBody = [];
            promisesQueue = [];
        }, 300);

        return new Promise<Response>((resolve, reject) => {
            promisesQueue.push({resolve, reject});
        });
    };
})();

export default class UserPreference extends SimpleModel<Record<string, any>> implements IUserPreference {
    constructor(protected repository: UserPreferencesRepository, attributes: IUserPreferenceModel) {
        super(attributes);

        this.events.dispatch(UserPreferenceEvents.CONSTRUCTED, {attributes});
    }

    isExists(): boolean {
        return this.getAttribute('id') != null;
    }

    fill(attributes: Record<string, any>) {
        this.events.dispatch(UserPreferenceEvents.FILLED, {
            attributes,
            preference: this
        });

        super.fill(attributes);
    }

    async save(attributes: Partial<IUserPreferenceModel> | null = null): Promise<boolean> {
        if (attributes) {
            this.fill(attributes);
        }

        this.events.dispatch(UserPreferenceEvents.BEFORE_SAVE, {preference: this});

        return app('http').withRequestsSender(requestSender, http => {
            return http.route('profile.update-preference', {}, {
                headers: {'Content-Type': 'application/json'},
                body: this.getAttributes(),
            });
        }).then(() => {
            this.events.dispatch(UserPreferenceEvents.SAVED, {preference: this});

            return true;
        });
    }

    protected get events() {
        return app('events');
    }
}
